import { Box } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
    AdminEntityType,
    useAdminListAllEntitiesQuery,
} from '../../../autogen/bff-api'
import { DebugPrint } from '../DebugPrint'
interface Props {
    entityType: AdminEntityType
}

export const AllEntities: React.FC<Props> = ({ entityType }) => {
    const { t } = useTranslation()
    const { data, refetch } = useAdminListAllEntitiesQuery({
        entityType: entityType,
    })

    useEffect(() => {
        refetch()
    }, [entityType])

    if (!data) {
        return <div>{t('Loading...')}</div>
    }

    return (
        <Box
            bg="smPanelBackground"
            borderRadius={10}
            mt="20px"
            boxShadow="smCard"
        >
            <Box>{data && <DebugPrint data={data} />}</Box>
        </Box>
    )
}
